export default __webpack_public_path__ + "static/acquisiton-color.url-c144b8ca4fc2f8661a09ddbcefdce992.svg";